const details = {
  sessions: {
      title: 'Analysis Sessions',
      noSessions: 'No analysis sessions',
      createFirst: 'Start your first analysis',
      loadMore: 'Load More',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this session?',
      view: 'View Details',
      resume: 'Resume',
    },
  errors: {
      createFailed: 'Failed to create session',
      analysisFailed: 'Analysis failed',
      loadFailed: 'Failed to load data',
      exportFailed: 'Export failed',
      connectionLost: 'Connection lost. Please try again.',
      sessionLoadFailed: 'Failed to load session',
      sessionsFetchFailed: 'Failed to fetch sessions',
      sessionDeleteFailed: 'Failed to delete session',
      cadLinkFailed: 'Failed to link CAD',
      analysisRequestFailed: 'Analysis request failed (HTTP {{status}})',
      httpError: 'HTTP error ({{status}})',
      noResponseBody: 'The server returned no response body',
      allFieldsRequired: 'Please fill in all required fields',
      specsRequiredToResume: 'Specifications are required to resume the analysis',
      noSessionToExport: 'There is no session to export',
    },
  success: {
      analysisComplete: 'Analysis completed',
      exported: 'Export completed',
      sessionDeleted: 'Session deleted',
    },
  knowledge: {
      title: 'Knowledge References',
      references: 'Related Knowledge',
      document: 'Document',
      relevance: 'Relevance',
      snippet: 'Snippet',
      noReferences: 'No related knowledge found',
    },
  confirm: {
      backToConditions: {
        title: 'Back to case conditions',
        description: 'Your edits to the design changes have not been saved. Going back discards all of them and this action cannot be undone. Are you sure you want to go back?',
        confirm: 'Discard and go back',
      },
      switchWorkflowMode: {
        title: 'Switch workflow mode',
        description: 'The staged workflow in progress will be discarded. The text you entered and your position in the workflow cannot be restored. Are you sure you want to switch?',
        confirm: 'Switch',
      },
      normalMode: {
        title: 'Return to normal mode',
        description: 'Your unsaved input will be discarded when you switch modes, and this action cannot be undone. Are you sure you want to switch?',
        confirm: 'Switch',
      },
      regenerateStage: {
        title: 'Confirm regeneration',
        description: 'Any generated candidates you have not yet reviewed will be discarded and replaced with a new set. This action cannot be undone. Are you sure you want to regenerate?',
        confirm: 'Regenerate',
      },
      regeneratePrecheck: {
        title: 'Regenerate pre-check items',
        description: 'Saving the design changes regenerates the pre-check items, and every answer you have already entered will be lost. This action cannot be undone. Are you sure you want to continue?',
        confirm: 'Continue',
      },
    },
  case: {
      title: 'Create GDS Case',
      description: 'Create a DRBFM case from the drawing page and the GDS transfer change summary.',
      startCase: 'Start with GDS Case',
      normalMode: 'Back to Standard DRBFM',
      referenceDrawing: 'Reference drawing: page {{page}}',
      documentId: 'Document ID {{id}}',
      imageId: 'Image ID {{id}}',
      fields: {
        title: 'Case Title',
        productName: 'Product',
        targetPart: 'Target Part',
        changeSummary: 'Change Summary',
      },
      required: '{{field}} is required',
      extractChanges: 'Extract Changes',
      extractingChanges: 'Extracting Changes',
      reviewTitle: 'Review Changes',
      reviewDescription: 'Prepare the extracted technical changes as DRBFM input.',
      noChanges: 'No changes were extracted.',
      changeNumber: 'Change {{number}}',
      confidence: 'Confidence {{value}}%',
      changedItem: 'Changed Item',
      oldSpecification: 'Old Specification',
      newSpecification: 'New Specification',
      technicalChange: 'Technical Change',
      backToConditions: 'Back to Case Conditions',
      generatingPrecheck: 'Generating Precheck',
      continueToPrecheck: 'Continue to Precheck',
      precheckTitle: 'Precheck',
      precheckDescription: 'Clarify unknowns before moving to DRBFM analysis.',
      noPrecheckItems: 'No precheck items.',
      answer: 'Answer',
      answerHelper: 'Typing marks this as answered',
      backToChangeReview: 'Back to Change Review',
      generatingDrbfm: 'Generating DRBFM',
      generateDrbfm: 'Generate DRBFM',
      answerRequired: 'Answer every precheck item or mark it as unknown or not applicable.',
      refetching: 'Refreshing',
      refetchResults: 'Refresh Results',
      analyzingLabel: 'Analyzing DRBFM case',
      exportMissing: 'No DRBFM result is available to export',
      exportFailed: 'Failed to export HTML',
      missingCase: 'Case has not been created.',
      missingAnalysisSession: 'Analysis session has not been created.',
      createCaseFailed: 'Failed to create case.',
      generatePrecheckFailed: 'Failed to generate precheck.',
      fetchResultsFailed: 'Failed to fetch analysis results.',
      analyzeFailed: 'Analysis failed.',
      answerStatus: {
        unanswered: 'Unanswered',
        answered: 'Answered',
        unknown: 'Unknown',
        not_applicable: 'Not applicable',
      },
    },
  drawingEvidence: {
      title: 'Drawing Evidence',
      missingDocumentId: 'Drawing evidence does not include a document ID.',
      imageNotFound: 'No image was found for the target page.',
      imageLoadFailed: 'Failed to load the drawing image.',
      notLinked: 'No drawing evidence is linked yet.',
      openDocumentPage: 'Open document page',
      goToDocument: 'Document',
      missingNormalizedBbox: 'No normalized bbox is available. Check the evidence location on the document page.',
    },
  decisionMemory: {
      title: 'Design Decision Memory',
      close: 'Close design decision memory',
      selectFailureMode: 'Select a failure mode.',
      severity: 'Severity {{value}}',
      evidenceAvailable: 'Evidence available',
      drawingLinked: 'Drawing linked',
      questionsGenerated: 'Questions generated',
      knowledgeLinked: 'Checked against related knowledge',
      knowledgeUnlinked: 'No related knowledge is linked',
      additionalReviewNeeded: 'Additional review needed',
      noAdditionalQuestions: 'No additional questions',
      reviewComment: 'Review {{description}} as RPN {{rpn}}. {{evidenceText}}, {{questionText}}.',
      followUpQuestions: 'AI Follow-up Questions',
      usedPrecheckAnswers: 'Answers Used in Precheck',
      unresolvedAssumptions: 'Unresolved Assumptions',
      relatedKnowledgeSummary: 'Related Knowledge Summary',
      relevance: 'Relevance {{value}}',
      confidence: 'Confidence {{value}}',
      confirmInDrawing: 'Confirm in Drawing',
      decisionBasisTitle: 'AI rationale and evidence',
      originatingChange: 'Originating design change',
      changeDetailsUnavailable: 'Design-change details are unavailable',
      causalHypothesis: 'Causal hypothesis assembled by AI',
      cause: 'Cause hypothesis',
      failureMode: 'Failure-mode candidate',
      effect: 'Expected effect',
      recordedEvidence: 'Recorded causal evidence',
      evidenceNotGenerated: 'No causal evidence supporting this candidate has been recorded yet. A designer must validate the causal relationship.',
      evidenceLevel: {
        direct: 'Direct evidence',
        supported: 'Supporting evidence',
        assumption: 'Assumption',
      },
      evidenceBoundary: 'This AI candidate referenced {{count}} related sources. The source count does not prove causality; a designer must validate it.',
      humanDecisionTitle: 'Designer decision',
      humanDecisionDescription: 'Adopt the AI candidate as-is, or create a revised candidate from an instruction and decide.',
      adopt: 'Adopt',
      adoptCandidate: 'Adopt this AI candidate',
      readoptCandidate: 'Reconsider and adopt',
      rejectCandidate: 'Reject',
      revisionInstruction: 'Revision instruction for AI',
      revisionPlaceholder: 'e.g. Focus the cause on crankshaft lubrication loss and shorten the effect.',
      generateRevision: 'Generate AI revision',
      revisionPreview: 'AI revision (not applied)',
      decisionBasis: 'Basis',
      applyRevision: 'Adopt and apply revision',
      discardRevision: 'Discard revision',
      revisionFailed: 'The AI revision could not be generated.',
      reviewFailed: 'The design decision could not be saved.',
      excludedHistory: '{{count}} rejected or superseded records are hidden from the list and retained in decision history.',
      showExcludedHistory: 'Show rejected and superseded',
      showActiveResults: 'Back to current results',
      historyTitle: 'Decision history',
      historyDescription: 'These records were excluded as rejected or superseded. Rejected design changes can be returned for review, and rejected failure modes can be reconsidered and adopted.',
      restoreForReview: 'Return for review',
      rejectedStatus: 'Rejected',
      supersededStatus: 'Superseded',
      rejectDesignChangeTitle: 'Reject this design change?',
      rejectDesignChangeDescription: 'Rejecting this change also hides {{failureModes}} related failure modes and {{countermeasures}} countermeasures from the current results. You can return it for review from decision history.',
      rejectFailureModeTitle: 'Reject this failure mode?',
      rejectFailureModeDescription: 'Rejecting this failure mode also hides {{countermeasures}} related countermeasures from the current results. You can reconsider and adopt it from decision history.',
      confirmReject: 'Reject',
    },
  cadLink: {
      parseError: 'Unable to read part-label JSON',
      partsArrayRequired: 'Provide a parts array or an array of part labels',
      duplicatePartLabel: 'Part label {{index}} repeats a part name',
      invalidPartLabel: 'Part label {{index}} is not in a valid format',
      inputHelper: 'Selecting a CAD model automatically links failure modes to matching 3D locations after DRBFM analysis.',
      partLabelsJson: 'Part-label JSON',
      partLabelsHelper: 'Paste a full cover_part_labels.json file or a parts array to use it as priority labels.',
      bulkView: 'View All in 3D',
      unlinkedCount: '{{count}} failure modes are not linked.',
      partialResolved: 'CAD link partially unresolved: {{linked}} linked, {{unresolved}} unresolved',
      linkComplete: 'CAD link complete: {{linked}} linked',
      linkCompleteWithUnresolved: 'CAD link complete: {{linked}} linked, {{unresolved}} unresolved',
      linkFailedWithCode: 'Failed to link CAD: {{code}}',
      noLinks: 'This DRBFM result has no CAD links yet.',
      linkHelper: 'Link failure modes to the selected CAD model',
      linking: 'Linking...',
      link: 'Link CAD',
      labelEditor: {
        open: 'Register Parts in 3D',
        title: 'Register Parts in 3D',
        modelRequired: 'Select a CAD model',
        modelLoadFailed: 'Failed to load the CAD model',
        selectedPoint: 'Selected point',
        instructions: 'Rotate or zoom the model, then click the shape to register as a part.',
        position: 'Selected coordinates',
        noPointSelected: 'Not selected',
        labelName: 'Part name',
        labelPlaceholder: 'e.g. Main hinge',
        category: 'Category',
        categoryPlaceholder: 'e.g. Rotation / fitting',
        note: 'Note',
        requiredFields: 'Select a CAD position and enter a part name and category',
        duplicateLabel: 'A part with this name is already registered',
        add: 'Add Part',
        registered: 'Parts to Register',
        empty: 'No parts have been registered',
        delete: 'Delete part',
        apply: 'Apply Labels',
      },
      view3DTooltip: 'Show this part in the 3D viewer',
      view3DUnavailable: 'No CAD model is linked or the session ID is missing',
      view3DLabel: 'View in 3D',
      selectFailureModeLabel: 'Select failure mode: {{description}}',
      designChangeExpand: 'Open design-change details',
      designChangeCollapse: 'Close design-change details',
      failureModeExpand: 'Open failure-mode details',
      failureModeCollapse: 'Close failure-mode details',
    },
  convert: {
      dialogTitle: 'Convert to Verification Items',
      buttonLabel: 'Convert to Verification Items',
      steps: {
        selectFailureModes: 'Select Failure Modes',
        chooseTarget: 'Choose Target',
        preview: 'Preview',
      },
      classifications: {
        performance: 'Performance',
        function: 'Function',
        reliability: 'Reliability',
        safety: 'Safety',
        cost: 'Cost',
        maintenance: 'Maintenance',
      },
      methods: {
        analysis: 'Analysis',
        pre_test: 'Pre-test',
        actual_confirm: 'Actual Confirmation',
        dr1: 'DR1',
        design_calc: 'Design Calculation',
        knowhow: 'Know-how',
      },
      fetchSessionsFailed: 'Failed to load verification sessions',
      convertFailed: 'Failed to convert to verification items',
      defaultSessionTitle: 'DRBFM link: {{itemName}}',
      selectFailureModesDescription: 'Select failure modes to convert ({{selected}}/{{total}} selected)',
      selectAll: 'Select All',
      deselectAll: 'Clear All',
      existingSession: 'Add to Existing Session',
      verificationSession: 'Verification Session',
      unit: 'Unit',
      createNewUnit: 'Create New Unit',
      newSession: 'Create New Session',
      sessionTitle: 'Session Title',
      modelName: 'Model Name',
      modelNamePlaceholder: 'e.g., VARIAXIS i-800 NEO',
      unitNumber: 'Unit Number',
      unitName: 'Unit Name',
      previewDescription: 'The following {{count}} verification items will be generated.',
      itemName: 'Item Name',
      classification: 'Classification',
      standardTarget: 'Standard/Target',
      verificationMethod: 'Verification Method',
      destination: 'Destination:',
      destinationNew: 'New session "{{title}}"',
      destinationExisting: 'Existing session "{{title}}"',
      successTitle: 'Added {{count}} verification items',
      successDescription: 'Conversion from DRBFM analysis results is complete.',
      viewVerificationItems: 'View Verification Items',
      back: 'Back',
      next: 'Next',
      submitting: 'Converting...',
      submit: 'Add to Verification Items',
    },
};

export default details;
